import { render, staticRenderFns } from "./ToolFpaWhatIf.vue?vue&type=template&id=b1bf508c&scoped=true"
import script from "./ToolFpaWhatIf.vue?vue&type=script&lang=js"
export * from "./ToolFpaWhatIf.vue?vue&type=script&lang=js"
import style0 from "./ToolFpaWhatIf.vue?vue&type=style&index=0&id=b1bf508c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bf508c",
  null
  
)

export default component.exports